import { Howl } from 'howler';
import React, { useEffect, useRef, useState } from 'react';
import { useSessionStorage } from 'react-use';
import { responsive } from '../responsive';

import Context from './context'
import underwater from './underwater.mp3'

export const headerHeight = responsive('3.5em', '6em')

const Provider = ({ children }) => {
  const [hideHeader, setHideHeader] = useState()
  const [headerColor, setHeaderColor] = useState('white')
  // const [pos, setPos] = useState('fixed').
  const [isPlaying, setPlaying] = useSessionStorage('coral:sound_playing')
  const [notifiedSound, setNotified] = useSessionStorage('coral:sound_playing_notify')
  const howlerRef = useRef()
  useEffect(() => {
    howlerRef.current = new Howl({
      src: [underwater],
      loop: true,
      // autoplay: true,
      volume: 0.5,
    });
  }, [])
  useEffect(() => {
    if (howlerRef.current) {
      if (isPlaying) {
        howlerRef.current.play()
      } else {
        howlerRef.current.pause()
      }
    }
  }, [isPlaying])
  return (
    <Context.Provider
      value={{
        hideHeader,
        setHideHeader,
        headerHeight,
        headerColor,
        setHeaderColor,
        isPlaying,
        setPlaying,
        notifiedSound,
        setNotified,
      }}
    >
      {children}
    </Context.Provider>
  )
}

export default Provider;
